import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import { useCallback, useEffect, useRef } from "react";
import Snackbar from "@mui/material/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { MuiBox, MuiTypography } from "..";
import { TOAST_AUTO_HIDE_DURATION } from "../../helpers/constants";
import { toastSelector } from "../../redux/slices/appState/appStateSelector";
import { toggleToast } from "../../redux/slices/appState/appStateSlice";
import { StyledSnackbarContent, ToastWrapper } from "./MuiToast.style";

export type ToastDisplayType = "success" | "info" | "warning" | "error";

const StyledSnackbar = styled(Snackbar)`
  margin-bottom: 5px;
`;

export const MuiToast = () => {
  const dispatch = useDispatch();
  const toastState = useSelector(toastSelector);

  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const hideToast = useCallback(() => {
    dispatch(toggleToast({ ...toastState, open: false }));
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (timerRef.current) clearTimeout(timerRef.current);
  }, [toastState]);

  useEffect(() => {
    if (toastState.open) {
      timerRef.current = setTimeout(() => {
        hideToast();
      }, toastState.autoHideDuration ?? TOAST_AUTO_HIDE_DURATION);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [toastState.open]);

  const renderMessageWithStartIcon = () => {
    return (
      <ToastWrapper>
        <MuiBox className="message-container">
          <TaskAltRoundedIcon className="check-image" />
          <MuiTypography variant="h3" className="message">
            {toastState.message}
          </MuiTypography>
        </MuiBox>
      </ToastWrapper>
    );
  };

  return (
    <StyledSnackbar
      open={toastState.open}
      disableWindowBlurListener
      onClose={hideToast}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      <StyledSnackbarContent
        type={toastState?.type ?? "success"}
        message={renderMessageWithStartIcon()}
        classes={{ root: "custom-snackbar" }}
      />
    </StyledSnackbar>
  );
};
